import { BaseDto } from "./base.dto"

import * as _ from 'lodash'

import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"

export class AdminFindSizeChartDto extends PagingDto {
  searchText?: string
}

export class AdminSizeChartDto extends BaseDto {
  type: string
  image: FileDto
  enabled: boolean
  content: string
  contentKh: string
  data: any[]

  static create() {
    return _.assign(new AdminSizeChartDto(), {
      type: '',
      content: '',
      contentKh: ''
    })
  }
}

export class AdminCreateSizeChartDto {
  type: string
  data?: any
  imageId?: string
  enabled: boolean
  content?: string
  contentKh?: string
}

export class AdminUpdateSizeChartDto {
  type?: string
  imageId?: string
  content?: string
  contentKh?: string
  data?: any
}

export class AdminFindSizeChartTitleDto extends PagingDto {
  searchText?: string
}

export class AdminCreateSizeChartTitleDto {
  title: string
  titleKh: string
  enabled: boolean
}

export class AdminUpdateSizeChartTitleDto {
  title?: string
  titleKh?: string
}

export class AdminSizeChartTitleDto extends BaseDto {
  id: string
  title: string
  titleKh: string
  enabled: boolean
}